import React, { useContext, useEffect, useState } from "react";
import { View, Text, TouchableOpacity } from "react-native";
import { Avatar } from "react-native-elements";
import { useNavigation } from "@react-navigation/native";

import {
  ButtonLogout,
  ContentAvatar,
  ContentEditProfile,
  DataUser,
  IconFE,
  TextButtonLogout,
  TextEditProfile,
  TitleDataUser,
} from "./styles";
import { Container, Content, TextField } from "../../components";
import { themes } from "../../design/colors";
import UserContext from "../../context/user";
import AsyncStorage from "@react-native-async-storage/async-storage";

function Profile() {
  const navigation = useNavigation();
  const { user } = useContext(UserContext);

  const [name, setName] = useState(user.name);
  const [email, setEmail] = useState(user.email);

  async function logout() {
    await AsyncStorage.removeItem('@lmatransportes:role');
    await AsyncStorage.removeItem('@lmatransportes:accessToken');
    await AsyncStorage.removeItem('@lmatransportes:name');
    await AsyncStorage.removeItem('@lmatransportes:email');
    navigation.reset({
      index: 0,
      routes: [{ name: "Login" }],
    });
  }



  return (
    <Container>
      <Content>
        <ContentAvatar>
          <Avatar
            rounded
            size="xlarge"
            title={user.initials_name}
            overlayContainerStyle={{
              backgroundColor: themes.colors.primary,
            }}
          />
          <ContentEditProfile onPress={() => navigation.navigate('UpdateProfile')}>
            <TextEditProfile>
              Mudar senha <IconFE name="edit" size={15} color={themes.colors.primary} />
            </TextEditProfile>
          </ContentEditProfile>
        </ContentAvatar>
        <View style={{ marginTop: 30 }}>
          <TitleDataUser>Nome completo</TitleDataUser>
          <DataUser>{user.name}</DataUser>
        </View>

        <View style={{ marginTop: 30 }}>
          <TitleDataUser>Email</TitleDataUser>
          <DataUser>{user.email}</DataUser>
        </View>

        <View style={{ marginTop: 30 }}>
          <TitleDataUser>Tipo de acesso</TitleDataUser>
          <DataUser>{user.role_name ?? user.roleName}</DataUser>
        </View>
      </Content>
      <ButtonLogout onPress={logout} activeOpacity={0.8}>
        <TextButtonLogout>
          Sair <IconFE name="log-out" size={15} color={themes.colors.red1} />
        </TextButtonLogout>
      </ButtonLogout>
    </Container>
  );
}

export default Profile;
